// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '이동됨 ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => '명령',
  accControlKey: () => '닫기',
  accPositionAfter: () => '이후',
  accPositionBefore: () => '이전',
  accReorderInstructions: (p: { keyPressed: string }) =>
    p['keyPressed'] + '과(와) Shift 키를 길게 누른 채, 화살표 키를 사용하여 순서를 바꿉니다.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '다음과 같이 완전한 날짜를 입력하십시오. ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '다음과 같이 월과 연도를 입력하십시오. ' + p['dateExample'] + '.',
  chart_labelGroup: () => '그룹',
  chart_labelSeries: () => '계열',
  chart_labelValue: () => '값',
  checkboxSet_requiredMessageDetail: () => '필수',
  checkbox_requiredMessageDetail: () => '필수',
  close: () => '닫기',
  collection_noData: () => '표시할 데이터 없음.',
  collection_selectAllRows: () => '모든 행 선택',
  collection_selectRow: (p: { ROW_NAME: string }) => p['ROW_NAME'] + ' 행 선택',
  collection_sortDisabled: () => '정렬 불가능',
  collection_sortEnabled: () => '정렬 가능',
  confirmation: () => '확인',
  datePicker_currentDate: () => '현재 날짜',
  datePicker_goToToday: () => '오늘로 이동',
  datePicker_label: () => '날짜 선택기',
  datePicker_month: () => '월',
  datePicker_months: () => '개월',
  datePicker_next: () => '다음',
  datePicker_nextDecade: () => '다음 10년',
  datePicker_nextMonth: () => '다음 월',
  datePicker_prev: () => '이전',
  datePicker_prevDecade: () => '이전 10년',
  datePicker_prevMonth: () => '이전 월',
  datePicker_restricted: () => '제한됨',
  datePicker_selected: () => '선택됨',
  datePicker_today: () => '오늘',
  datePicker_weekNum: (p: { NUM: string }) => '주 ' + p['NUM'],
  datePicker_weekNumColLabel: () => '주 번호',
  datePicker_year: () => '연도',
  datePicker_years: () => '년',
  error: () => '오류',
  expandableList_expandCollapseInstructionText: () => '화살표 키를 사용하여 확장 및 축소합니다',
  expandableList_groupCollapse: () => '축소됨',
  expandableList_groupExpand: () => '확장됨',
  filePicker_addFiles: () => '파일 추가',
  filePicker_dropzonePrimaryText: () => '끌어 놓기',
  filePicker_dropzoneSecondaryText: () => '파일을 선택하거나 여기에 끌어 놓기',
  filePicker_dropzoneSecondaryTextMultiple: () => '파일을 선택하거나 여기에 끌어 놓기',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    p['fileTypes'] + ' 유형의 파일을 업로드할 수 없습니다',
  filePicker_singleFileUploadError: () => '파일을 한 번에 하나씩 업로드하십시오',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' 유형의 파일을 업로드할 수 없습니다',
  filePicker_unknownFileTypeUploadError: () => '알 수 없음',
  formControl_clear: () => '지우기',
  formControl_day: () => '일',
  formControl_helpAvailable: () => '도움말 사용 가능',
  formControl_hide: () => '숨기기',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    ((
      ({ one: new Intl.NumberFormat('ko').format(p['CHARACTER_LIMIT']) + '자' }) as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('ko').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ko').format(p['CHARACTER_LIMIT']) + '자') + ' 제한에 도달했습니다.',
  formControl_loading: () => '로드 중',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '최대 ' + p['MAX_LENGTH'] + '자를 입력할 수 있습니다.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + '자 남음.',
  formControl_month: () => '월',
  formControl_readOnly: () => '읽기 전용',
  formControl_requiredMessageDetail: () => '값을 입력하십시오.',
  formControl_show: () => '표시',
  formControl_year: () => '연도',
  gantt_labelDate: () => '날짜',
  gantt_labelEnd: () => '끝',
  gantt_labelLabel: () => '레이블',
  gantt_labelRow: () => '행',
  gantt_labelStart: () => '시작',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. 일치하는 섹션을 찾을 수 없습니다.',
  indexer_keyboardInstructionText: () => 'Enter 키를 눌러 값을 선택합니다.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + '과(와) ' + p['TO_SECTION'] + ' 사이.',
  indexer_touchInstructionText: () =>
    '길게 두번 눌러서 제스처 모드로 전환한 다음 위로 또는 아래로 드래그하여 값을 조정합니다.',
  info: () => '정보',
  inputDateMask_date_cleared: () => '날짜 지워짐',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => '비어 있음',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' 또는 이전의 날짜를 입력하십시오.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    p['min'] + ' 또는 이후의 날짜를 입력하십시오.',
  inputDatePicker_dateRestrictionMessageDetail: () => '사용 가능한 날짜를 입력하십시오.',
  inputDatePicker_instruction: () => '달력에 액세스하려면 Tab을 누르십시오.',
  inputDatePicker_selectDate: () => '날짜 선택',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    p['max'] + ' 또는 이전의 월과 연도를 입력하십시오.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    p['min'] + ' 또는 이후의 월과 연도를 입력하십시오.',
  inputNumber_converterParseError: () => '숫자를 입력하십시오.',
  inputNumber_decrease: () => '줄이기',
  inputNumber_increase: () => '늘이기',
  inputPassword_hidden: () => '비밀번호 숨김',
  inputPassword_hide: () => '비밀번호 숨기기',
  inputPassword_show: () => '비밀번호 표시',
  inputSensitiveText_hidden: () => '민감한 텍스트 숨김',
  list_msgFetchCompleted: () => '로드됨',
  list_msgFetchingData: () => '로드 중',
  list_suggestion: () => '제안',
  messageToast_allMessagesClosed: () => '모든 토스트 메시지가 닫혔습니다.',
  message_close: () => '닫기',
  message_confirmation: () => '성공',
  message_error: () => '오류',
  message_info: () => '정보',
  message_navigationFromMessagesRegion: () =>
    '메시지 영역 입력 중. F6를 눌러 이전에 포커스된 요소로 돌아갑니다.',
  message_navigationToMessagesRegion: () =>
    '메시지 영역에 새 메시지가 있습니다. F6를 눌러 가장 최근 메시지 영역으로 이동합니다.',
  message_warning: () => '경고',
  noData_message: () => '표시할 항목이 없습니다',
  overflowItemLabel: () => '추가 탭',
  plural_separator: () => ', ',
  progressIndeterminate: () => '진행 중',
  radio_helpForRadio: () => '라디오 단추에 대한 도움말',
  radio_requiredMessageDetail: () => '값을 선택하십시오.',
  selectMultiple_apply: () => '적용',
  selectMultiple_back: () => '뒤로',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    '왼쪽 및 오른쪽 화살표 키를 사용하여 선택한 값을 강조 표시합니다.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Backspace 또는 Delete를 눌러 선택한 값을 제거합니다.',
  selectMultiple_selectedValues: () => '선택된 값',
  selectMultiple_showSelectedValues: () => '선택한 값만 표시합니다.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + '개 값이 선택되었습니다.',
  select_addToList: () => '목록에 추가',
  select_addToListAvailable: () => '목록에 추가 사용 가능',
  select_moreSearchOptions: () => '추가 검색 옵션',
  select_moreSearchOptionsAvailable: () => '추가 검색 옵션 사용 가능',
  select_noMatchesFound: () => '일치 항목을 찾을 수 없습니다.',
  select_oneMatchFound: () => '일치하는 항목이 한 개 발견되었습니다.',
  select_requiredMessageDetail: () => '값을 선택하십시오.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '개의 일치 항목이 발견되었습니다.',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '개 이상의 일치 항목이 발견되었습니다.',
  selectorAll_deselectAll: () => '모두 선택 해제',
  selectorAll_selectAll: () => '모두 선택',
  selector_selected: () => '체크박스 선택됨',
  selector_unselected: () => '체크박스 선택 안됨',
  tabBarNavigationList_removeCueText: () => '제거 가능',
  timeComponent_tooltipZoomIn: () => '확대',
  timeComponent_tooltipZoomOut: () => '축소',
  train_current: () => '현재',
  train_message_type: () => '메시지 유형',
  train_not_visited: () => '방문 안함',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '단계 ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => '방문함',
  userAssistance_learnMore: () => '자세히',
  userAssistance_required: () => '필수',
  vis_clearSelection: () => '선택 지우기',
  vis_drillable: () => '드릴 가능',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' / ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => '움직이는 텍스트 선택',
  vis_marqueeZoomTooltip: () => '움직이는 텍스트 확대/축소',
  vis_noData: () => '표시할 데이터 없음',
  vis_panTooltip: () => '이동',
  vis_stateLoaded: () => '로드됨',
  vis_stateLoading: () => '로드 중',
  vis_stateSelected: () => '선택됨',
  vis_stateUnselected: () => '선택 취소됨',
  warn: () => '경고'
};
export default bundle;
